import { PaginatedResponseV2 } from 'clipsal-cortex-types/src/common/types';
import { getStringifiedQueryParams } from 'clipsal-cortex-utils/src/formatting/query-params';

import { AlertData } from '../../../api/api-site-alerts';
import { baseApi } from '../../../app/baseApi';
import { SiteAlertsQueryParams } from './site-alert-helpers';

export const alertApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSiteAlerts: builder.query<
      PaginatedResponseV2<AlertData>,
      { siteId: number; isActiveAlert: boolean; params: SiteAlertsQueryParams }
    >({
      query: ({ siteId, isActiveAlert, params }) => {
        const stringifiedParams = getStringifiedQueryParams<string>(params);
        return {
          url: `/fleet/sites/${siteId}/alerts?${stringifiedParams}&event_end_time__isnull=${isActiveAlert.toString()}`,
          method: 'GET',
        };
      },
      providesTags: (_, __, { siteId, isActiveAlert, params }) => [
        { type: 'SiteAlerts', siteId, isActiveAlert, ...params },
      ],
    }),
    getTenantAlerts: builder.query<
      PaginatedResponseV2<AlertData>,
      { isActiveAlert: boolean; params: SiteAlertsQueryParams }
    >({
      query: ({ isActiveAlert, params }) => {
        const stringifiedParams = getStringifiedQueryParams<string>(params);
        return {
          url: `/fleet/alerts?${stringifiedParams}&event_end_time__isnull=${isActiveAlert.toString()}`,
          method: 'GET',
        };
      },
      providesTags: (_, __, { isActiveAlert, params }) => [{ type: 'TenantAlerts', isActiveAlert, ...params }],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetSiteAlertsQuery, useGetTenantAlertsQuery } = alertApi;

export const useSiteAlerts = (
  siteId: number,
  isActiveAlert: boolean,
  params: SiteAlertsQueryParams,
  skip?: boolean
) => {
  const { data, isLoading, isFetching } = useGetSiteAlertsQuery(
    { siteId, isActiveAlert, params },
    { skip: !siteId || skip }
  );

  const dataCount = data?.count || 0;
  const totalPages = Math.ceil(dataCount / params.limit);

  return { alerts: data?.results || [], isLoading, isFetching, dataCount, totalPages };
};

export const useTenantAlerts = (isActiveAlert: boolean, params: SiteAlertsQueryParams, skip?: boolean) => {
  const { data, isLoading, isFetching } = useGetTenantAlertsQuery({ isActiveAlert, params }, { skip: skip });

  const dataCount = data?.count || 0;
  const totalPages = Math.ceil(dataCount / params.limit);

  return { alerts: data?.results || [], isLoading, isFetching, dataCount, totalPages };
};
